import styled from "styled-components"

export const Container = styled.div`
  z-index: -1;
`

export const ContainerModal = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2022;
`
